import React from "react";
import {Avatar, Breadcrumb, Card, Col, Row} from "antd";
import {Link} from "react-router-dom";

import BaseComponent from "../../redare/components/BaseComponent";
import icon16 from "../../assets/img/icon16.png";
import icon18 from "../../assets/img/icon18.png";
import icon21 from "../../assets/img/icon21.png";
import icon22 from "../../assets/img/icon22.png";
import icon25 from "../../assets/img/icon25.png";
import icon28 from "../../assets/img/icon28.png";

import {fnMenuFlag} from "../../common/Utils";
import MenuRolePermissionPresenter from "../../.gen/presenter/MenuRolePermissionPresenter";

export default class SystemSettingsPage extends BaseComponent {


    constructor(props) {
        super(props);
        this._user = window._workbench._user;
        if (this._user !== undefined) {
            this._isRoot = this._user.root;
            this._isAdmin = this._user.admin;
        }
        this.menuRolePermissionPresenter = new MenuRolePermissionPresenter(this);
    }

    componentDidMount() {
        this._loadMenuRolePermission();
    }

    _loadMenuRolePermission() {
        if (this._user !== undefined) {
            this.menuRolePermissionPresenter.findMenuRolePermissionByUserId({}, {}, (result) => {
                let data1 = result.data;
                let data = [];
                if (data1) {
                    data1.forEach((v, i) => {
                        if (v.webPath !== undefined && v.urlPath !== undefined) {
                            if (v.webPath === v.urlPath) {
                                data.push(v.webPath);
                            } else {
                                data.push(v.webPath, v.urlPath);
                            }
                        }
                        if (v.webPath !== undefined && v.urlPath === undefined) {
                            data.push(v.webPath);
                        }
                        if (v.webPath === undefined && v.urlPath !== undefined) {
                            data.push(v.urlPath);
                        }
                    });
                    this.setState({data});
                }
            })
        }
    }

    render() {
        let {data} = this.state;
        if (!data) {
            data = [];
        }
        let sysPathArr = data.filter(item => item !="/site/profile");
        return (
            <div className="SystemSettings-Page">
                <div className="bg-white bord-bot">
                    <div className="width-all padding02">
                        <Breadcrumb>
                            <Breadcrumb.Item><Link to="/">工作台</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>系统设置</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="width-all">
                    <div className="margin024">
                        <Card title="我的设置" bordered={false}>
                            <Row gutter={16} type="flex">
                                {
                                    // fnMenuFlag(data, '/site/profile', this._isRoot) ?
                                    <Col span={3} className="list-item">
                                        <Link to="/site/profile">
                                            <div className="icon-first">
                                                <Avatar shape="square" size={50} src={icon16}/>
                                            </div>
                                            <p>个人设置</p>
                                        </Link>
                                    </Col>
                                    // : null
                                }

                            </Row>
                        </Card>
                        <div className="line"></div>
                        {(sysPathArr && sysPathArr.length > 0 || this._isRoot || this._isAdmin) && <Card title="系统设置" bordered={false}>
                            <Row gutter={[16, 24]} type="flex">
                                {
                                    fnMenuFlag(data, '/application/list', this._isRoot) ?
                                        <Col span={3} className="list-item">
                                            <Link to="/application/list">
                                                <div className="icon-first">
                                                    <Avatar shape="square" size={50} src={icon18}/>
                                                </div>
                                                <p>应用设置</p>
                                            </Link>
                                        </Col> : null
                                }
                                {
                                    fnMenuFlag(data, '/user/manager', this._isRoot) ?
                                        <Col span={3} className="list-item">
                                            <Link to="/user/manager">
                                                <div className="icon-first">
                                                    <Avatar shape="square" size={50} src={icon21}/>
                                                </div>
                                                <p>用户管理</p>
                                            </Link>
                                        </Col> : null
                                }
                                {
                                    (this._isRoot || this._isAdmin) ?
                                        <Col span={3} className="list-item">
                                            <Link to="/role/permission/manager">
                                                <div className="icon-first">
                                                    <Avatar shape="square" size={50} src={icon22}/>
                                                </div>
                                                <p>角色权限管理</p>
                                            </Link>
                                        </Col> : null
                                }
                                {
                                    fnMenuFlag(data, '/site/dictionary', this._isRoot) ?
                                        <Col span={3} className="list-item">
                                            <Link to="/site/dictionary">
                                                <div className="icon-first">
                                                    <Avatar shape="square" size={50} src={icon25}/>
                                                </div>
                                                <p>字典管理</p>
                                            </Link>
                                        </Col> : null
                                }
                                {/*{*/}
                                {/*    fnMenuFlag(data, '/site/log', this._isRoot) ?*/}
                                {/*        <Col span={3} className="list-item">*/}
                                {/*            <Link to="/site/log">*/}
                                {/*                <div className="icon-first">*/}
                                {/*                    <Avatar shape="square" size={50} src={icon28}/>*/}
                                {/*                </div>*/}
                                {/*                <p>日志管理</p>*/}
                                {/*            </Link>*/}
                                {/*        </Col> : null*/}
                                {/*}*/}
                            </Row>
                        </Card>}
                    </div>
                </div>
            </div>
        )
    }
}
